import { defaultImage, Media } from '@hub/shared'
import { useTranslation } from 'react-i18next'
import './photo-legend.component.scoped.scss'

interface PhotoLegendProps {
  photo: Media
  showChangeIcon?: boolean
}

export default ({ photo, showChangeIcon = false }: PhotoLegendProps) => {
  const [t] = useTranslation('photoLegend')

  return (
    <div className="box p-3 photo-legend">
      {showChangeIcon && photo ? (
        <span className="change-icon">
          <i className="fa-regular fa-arrows-repeat"></i>
        </span>
      ) : null}
      <img
        src={photo?.imagens?.thumbnail?.url}
        className="img-fluid img-selected"
        title={t('titleImg')}
        alt={t('titleImg')}
        onError={({ currentTarget }) => {
          currentTarget.onerror = null
          currentTarget.src = defaultImage
        }}
      />
      <div className="gray text-medium pt-2 text-ellipsis-more">{photo?.legenda}</div>
    </div>
  )
}
